export default __webpack_public_path__ + "f2a003d05302d84113e45ceb84ca60d5.png";